import { createContext } from "react";

const IsWatchScreenContext = createContext();

export default IsWatchScreenContext;
